import React, { useEffect, useState } from 'react';
function getTargetTime(): number {
  const key = 'urgency_bar_end';
  const stored = localStorage.getItem(key);
  if (stored) {
    const val = parseInt(stored, 10);
    if (val > Date.now()) return val;
  }
  // 24 hours from now
  const end = Date.now() + 24 * 60 * 60 * 1000;
  localStorage.setItem(key, String(end));
  return end;
}
function formatTime(ms: number) {
  if (ms <= 0) return {
    h: '00',
    m: '00',
    s: '00'
  };
  const totalSec = Math.floor(ms / 1000);
  const h = String(Math.floor(totalSec / 3600)).padStart(2, '0');
  const m = String(Math.floor(totalSec % 3600 / 60)).padStart(2, '0');
  const s = String(totalSec % 60).padStart(2, '0');
  return {
    h,
    m,
    s
  };
}
export function UrgencyBar() {
  const [remaining, setRemaining] = useState(() => getTargetTime() - Date.now());
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(getTargetTime() - Date.now());
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const {
    h,
    m,
    s
  } = formatTime(remaining);
  return <div className="bg-gradient-to-r from-magenta via-purple-mid to-blue-electric py-3 px-5 text-center font-heading font-bold text-[0.95rem] tracking-[0.5px] animate-bar-pulse z-50 relative" data-id="element-311">
      ⏳ Esta oferta de lanzamiento vence en:{' '}
      <span className="inline-flex items-center gap-1 ml-2" data-id="element-312">
        <span className="bg-dark-bg/80 text-white py-[3px] px-[10px] rounded-md font-mono text-[1rem] tracking-widest" data-id="element-313">
          {h}
        </span>
        <span className="text-white/80" data-id="element-314">:</span>
        <span className="bg-dark-bg/80 text-white py-[3px] px-[10px] rounded-md font-mono text-[1rem] tracking-widest" data-id="element-315">
          {m}
        </span>
        <span className="text-white/80" data-id="element-316">:</span>
        <span className="bg-dark-bg/80 text-white py-[3px] px-[10px] rounded-md font-mono text-[1rem] tracking-widest" data-id="element-317">
          {s}
        </span>
      </span>
    </div>;
}